var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"box-container p-3"},[_vm._m(0),_c('p',{staticClass:"text-left d-inline"},[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline"},[_c('em',{staticClass:"far fa-exclamation-triangle text-danger"})])
}]

export { render, staticRenderFns }